import { defineStore } from "pinia";
import api from "@/api";
import {
  AverageGaps,
  ReflectionQuizScore,
} from "@/interfaces/catch-up.interface";

export const useCatchupStore = defineStore({
  id: "catchupStore",
  state: () => ({
    averageGapsData: null as AverageGaps | null,
    reflectionQuizzesAverageScoreData: null as ReflectionQuizScore[] | null,
    loader: {
      fetchAverageGapsData: false,
      fetchReflectionQuizzesAverageScoreData: false,
    },
  }),
  getters: {
    getAverageGapsData(): AverageGaps | null {
      return this.averageGapsData;
    },
    getReflectionQuizzesAverageScoreData(): ReflectionQuizScore[] | null {
      return this.reflectionQuizzesAverageScoreData;
    },
  },
  actions: {
    /**
     * Fetch average gaps data
     */
    async fetchAverageGapsData(payload: any) {
      this.loader.fetchAverageGapsData = true;

      try {
        const response = await api.post(
          "/v2/data/catchup/fetch-average-gaps-data",
          payload
        );
        if (response.status === 200) {
          this.averageGapsData = response.data.data;
        } else {
          throw new Error("Failed to fetch average gaps data.");
        }
      } catch (error) {
        console.error("Error fetching average gaps data: ", error);
        this.averageGapsData = null;
      } finally {
        this.loader.fetchAverageGapsData = false;
      }
    },

    /**
     * Fetch reflection quizzes average score data
     */
    async fetchReflectionQuizzesAverageScoreData(payload: any) {
      this.loader.fetchReflectionQuizzesAverageScoreData = true;

      try {
        const response = await api.post(
          "/v2/data/catchup/fetch-reflection-quizzes-average-score-data",
          payload
        );
        if (response.status === 200) {
          this.reflectionQuizzesAverageScoreData = response.data.data;
        } else {
          throw new Error(
            "Failed to fetch reflection quizzes average score data."
          );
        }
      } catch (error) {
        console.error(
          "Error fetching reflection quizzes average score data: ",
          error
        );
        this.reflectionQuizzesAverageScoreData = null;
      } finally {
        this.loader.fetchReflectionQuizzesAverageScoreData = false;
      }
    },
  },
  persist: true,
});
